
import { getInvoiceDetailsById, saveAndProceedInvoice } from 'core/services/api';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/esm/Button';
import { useHistory, useParams } from 'react-router';
import "./MainBillingModule.scss";
import TableRows from './components/treatmentAndDetails/TableRows';
import RenderPopover from './components/popover/RenderPopover';
import RenderPopoverInsurance from './components/popover/RenderPopoverInsurance';
import Select from "react-select";
import Toast from 'components/Toast';
import { MocImage } from 'core/widgets/TwoSplitLayout';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import RenderPopoverAdvance from './components/popover/RenderPopoverAdvance';
import { useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import Alert from 'react-bootstrap/esm/Alert';
import Card from 'react-bootstrap/esm/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { faCircle, faCircleDot } from '@fortawesome/free-regular-svg-icons';
import { v4 as uuidv4 } from 'uuid';


function MainBillingModule() {
  const history = useHistory();
  const [rowsData, setRowsData] = useState<any>([])
  const [invoice, setInvoice] = useState<any>([]);
  const [readOnly, setReadOnly] = useState<any>();
  const [loading, setLoading] = useState<any>(false)
  const [showConsultationChargesPopUp, setShowConsultationChargesPopUp] = useState<boolean>(false)
  const [showConsultationChargesAlert, setShowConsultationChargesAlert] = useState<boolean>(false)
  const [selectedInvoiceItem, setSelectedInvoiceItem] = useState<any>({})
  const { invoiceId }: any = useParams()
  const centerDetail = useSelector((state: any) => state?.user?.centerDetail)

  const element = document.getElementById("billing-cover")
  useEffect(() => {
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }, [element])

  //useEffect
  useEffect(() => {
    getInvoiceDetailsById(invoiceId).then((res: any) => {
      setInvoice(res);
      let isSuggestedConsultationChargesApplied = false
      setRowsData(res?.invoiceItems?.map((item: any) => {
        if (!item?.archive && item?.isSuggestedConsultationCharges) {
          isSuggestedConsultationChargesApplied = true
        }
        item.rowId = uuidv4();
        return item;
      }));

      if (res?.isEditable &&
        !isSuggestedConsultationChargesApplied &&
        (res?.suggestedConsultationCharges || res?.suggestedConsultationCharges === 0)) {
        setShowConsultationChargesAlert(true)
      }

      setReadOnly(!res?.isEditable);
    }).catch((err: any) => {
      console.log(err, "err");
    })

  }, [invoiceId])

  const redirectToPayments = ((id: any) => {
    setLoading(false)
    history.push({
      pathname: `/invoices/payments/${id}`,
      state: {
        advancePayment: amount.advancePayment,
        securityDeposit: amount.securityDeposit,
        totalPayable: Math.max(amount.amountAfterAdjustment, 0),
        location: "Billing"
      }

    })
  })

  //Treatment and Details
  const addTableRows = () => {
    const rowsInput = {
      rowId: uuidv4(),
      treatmentAndDetails: "",
      serviceId: "",
      completedBy: "",
      cost: 0,
      discount: "",
      quantity: 0,
      charges: 0,
      archive: false,
      totalTaxAmount: 0,
      deletionCheckRequired: false,
      reason: "",
      remarks: "",
      discountType: "PERCENTAGE",
      taxes: [
        { name: 'CGST', percentage: 0, amount: 0 },
        { name: 'IGST', percentage: 0, amount: 0 },
        { name: 'GST', percentage: 0, amount: 0 },
        { name: 'SGST', percentage: 0, amount: 0 }]
    }
    setRowsData([...rowsData, rowsInput])
  }

  const deleteTableRows = (index: any) => {
    if (rowsData[index].deletionCheckRequired === true) {
      toggleDisplayToast({
        text: "Please enter the deletion reason", type: "error", onClickText: "Save",
        onCloseText: "Close", textarea: "textarea", textareaContent: index
      })
    } else {
      const rows = [...rowsData]
      if (rowsData[index]?.isSuggestedConsultationCharges) {
        setShowConsultationChargesAlert(true)
      }
      rows.splice(index, 1)
      setRowsData(rows)
    }
  }

  const handleChange = (index: any, evnt: any) => {
    const { name, value } = evnt.target
    const rowsInput = [...rowsData]
    rowsInput[index][name] = value
    setRowsData(rowsInput)
  }

  const updateCostBasedQuantity = (index: any, evnt: any) => {
    if (Number(evnt.target.value) >= 0) {
      const rowsInput = [...rowsData]
      rowsInput[index]["quantity"] = evnt.target?.value
      rowsInput[index]["charges"] = evnt.target?.value * rowsInput[index].cost
      setRowsData(rowsInput);
    }
  }

  const updateEditableFields = (index: any, evnt: any) => {
    const rowsInput = [...rowsData];

    if (evnt.target != undefined) {
      if (evnt.target.name === "cost" && Number(evnt.target.value) >= 0) {
        rowsInput[index]["cost"] = evnt.target?.value;
        if (evnt.target.value == 0 || (rowsInput[index]["discountType"] === "AMOUNT" && evnt.target.value < rowsInput[index]["discount"])) {
          rowsInput[index]["discount"] = 0
        }
      }
      if (evnt.target.name === "discount" && Number(evnt.target.value.replace(/^0+/, '')) >= 0) {
        rowsInput[index]["discount"] = Number(evnt.target?.value.replace(/^0+/, ''));
      }
      if (evnt.target.name === "quantity" && rowsInput[index]["discountType"] === "AMOUNT" && rowsInput[index]["discount"] > rowsInput[index]["charges"]) {
        rowsInput[index]["discount"] = 0
      }
    }
    if (evnt?.label === "%") {
      rowsInput[index]["discountType"] = "PERCENTAGE";
      rowsInput[index]["discount"] = 0
    }
    if (evnt?.label === "CASH") {
      rowsInput[index]["discountType"] = "AMOUNT";
      rowsInput[index]["discount"] = 0
    }


    let totalCost = rowsInput[index].cost * (rowsInput[index].quantity || 1);
    let taxableAmount = totalCost;

    var discountAmount: any;

    if (rowsInput[index].discountType === 'PERCENTAGE') {
      discountAmount = (rowsInput[index].discount / 100) * totalCost;
      taxableAmount -= discountAmount;
    } else if (rowsInput[index].discountType === 'AMOUNT') {
      discountAmount = rowsInput[index].discount;
      taxableAmount -= discountAmount;
    }

    rowsInput[index]["amountAfterDiscount"] = taxableAmount;
    let totalTax = 0;

    if (["CGST", "IGST", "GST", "SGST"]?.includes(evnt?.target?.name) &&
      Number(evnt?.target?.value) >= 0) {
      const existingTax = rowsInput[index]["taxes"]?.find((item: any) => item.name === evnt?.target?.name);
      if (existingTax) {

        existingTax.amount = evnt?.target?.value;
        existingTax.percentage = ((evnt?.target?.value / rowsInput[index]["amountAfterDiscount"]) * 100)?.toFixed(2);
      } else {
        const newTax = { name: evnt?.target?.name, percentage: ((evnt?.target?.value / rowsInput[index]["amountAfterDiscount"]) * 100).toFixed(2), amount: evnt?.target?.value };
        rowsInput[index]["taxes"].push(newTax);
      }
    }
    else {
      rowsInput[index]["taxes"]?.map((each: any) => {
        each.percentage = ((each.amount / rowsInput[index]["amountAfterDiscount"]) * 100)?.toFixed(2);
      })

    }


    totalTax = rowsInput[index]["taxes"]?.reduce((sum: any, itm: any) => sum + Number(itm?.amount), 0)

    totalCost = taxableAmount + totalTax;
    rowsInput[index]["charges"] = totalCost;
    setRowsData(rowsInput);
  };


  //autofill when selecting the medicine
  const autofillData = (res: any, data: any, index: any) => {
    const rowsInput = [...rowsData]
    rowsInput[index]["treatmentAndDetails"] = res?.treatmentAndDetails
    rowsInput[index]["completedBy"] = res?.completedBy
    rowsInput[index]["cost"] = res?.cost
    rowsInput[index]["discount"] = res?.discount
    rowsInput[index]["charges"] = res?.charges
    rowsInput[index]["quantity"] = res?.quantity
    rowsInput[index]["amountAfterDiscount"] = res?.amountAfterDiscount
    rowsInput[index]["taxes"] = res?.taxes
    rowsInput[index]["serviceId"] = res?.serviceId
    rowsInput[index]["sacNumber"] = res?.sacNumber
    rowsInput[index]["discountType"] = res?.discountType
    rowsInput[index]["isEditable"] = res?.isEditable
    rowsInput[index]["reason"] = res?.reason
    setRowsData(rowsInput)
  }


  // const discountValue = invoice?.discount;
  const [amount, setamount] = useState<any>({
    id: "",
    amountBeforeDiscount: 0,
    discount: 0,
    discountedAmount: 0,
    discountMode: "",
    amountAfterDiscount: 0,
    amountAfterAdjustment: 0,
    advancePayment: 0,
    securityDeposit: 0,
    remarks: ""

  })
  //Discount Type
  //dropdown
  const discountType = [
    { label: "CASH", value: "AMOUNT" },
    { label: "%", value: "PERCENTAGE" }
  ]

  const discountDropdown = [
    { label: "CASH", value: "AMOUNT" },
    { label: "%", value: "PERCENTAGE" }
  ]





  //Discount
  // useEffect(() => {
  //   console.log(rowsData, "rowsData");
  //   const amountBeforeDiscountCal = rowsData
  //     .filter((item: any) => !item.archive)
  //     .reduce((a: any, item: any) => a + (item.charges || 0), 0);

  //   let amountAfterDiscountCal: any;
  //   let discountedAmounts;
  //   if (amount.discountMode === "PERCENTAGE") {
  //     const totalCharges = rowsData.reduce((a: any, item: any) => {
  //       return a + (item.charges || 0)
  //     }, 0)
  //     const discountedAmounts = (totalCharges *
  //       amount.discount /
  //       100)
  //     amountAfterDiscountCal = totalCharges - discountedAmounts
  //   }
  //   else {
  //     amountAfterDiscountCal = rowsData.reduce((a: any, item: any) => {
  //       return a + (item.charges || 0)
  //     }, 0) -
  //       (amount.discount)
  //     discountedAmounts = (rowsData.reduce((a: any, item: any) => {
  //       return a + (item.charges || 0)
  //     }, 0) *
  //       amount.discount) /
  //       100

  //   }

  //   setamount({
  //     ...amount,
  //     remarks: amount?.remarks,
  //     discountedAmount: Number(discountedAmounts),
  //     amountBeforeDiscount: amountBeforeDiscountCal?.toFixed(2),
  //     amountAfterDiscount: amountAfterDiscountCal?.toFixed(2),
  //     amountAfterAdjustment: amountAfterDiscountCal?.toFixed(2) - (amount.securityDeposit || 0) - (amount.advancePayment || 0)
  //   })

  //   function getAmountAfterAdjustment() {
  //     if (Number.isNaN(amount.advancePayment) && Number.isNaN(amount.securityDeposit)) {
  //       return amount.amountAfterDiscount
  //     }
  //     if (Number.isNaN(amount.advancePayment)) {
  //       return amount.amountAfterDiscount - Number(amount.securityDeposit)
  //     }
  //     if (Number.isNaN(amount.securityDeposit)) {
  //       return amount.amountAfterDiscount - Number(amount.advancePayment)
  //     }
  //     else {
  //       return Number(amount.amountAfterDiscount) - Number(amount.securityDeposit) - Number(amount.advancePayment);
  //     }

  //   }
  // }, [rowsData, amount.discount, amount.securityDeposit, amount.advancePayment, amount.discountMode, amount.amountAfterAdjustment, amount.amountBeforeDiscount])
  useEffect(() => {
    const filteredRowsData = rowsData.filter((item: any) => !item.archive); // Filtering out items with "archive" key

    const amountBeforeDiscountCal = filteredRowsData.reduce((a: any, item: any) => a + (item.charges || 0), 0);

    let amountAfterDiscountCal: any;
    let discountedAmounts: any;

    if (amount.discountMode === "PERCENTAGE") {
      const totalCharges = filteredRowsData.reduce((a: any, item: any) => a + (item.charges || 0), 0);
      discountedAmounts = (totalCharges * amount.discount / 100);
      amountAfterDiscountCal = totalCharges - discountedAmounts;
    } else {
      amountAfterDiscountCal = filteredRowsData.reduce((a: any, item: any) => a + (item.charges || 0), 0) - (amount.discount);
      discountedAmounts = (filteredRowsData.reduce((a: any, item: any) => a + (item.charges || 0), 0) * amount.discount) / 100;
    }

    setamount({
      ...amount,
      remarks: amount?.remarks,
      discountedAmount: Number(discountedAmounts),
      amountBeforeDiscount: amountBeforeDiscountCal?.toFixed(2),
      amountAfterDiscount: amountAfterDiscountCal?.toFixed(2),
      amountAfterAdjustment: amountAfterDiscountCal?.toFixed(2) - (amount.securityDeposit || 0) - (amount.advancePayment || 0),
    });

    function getAmountAfterAdjustment() {
      if (Number.isNaN(amount.advancePayment) && Number.isNaN(amount.securityDeposit)) {
        return amount.amountAfterDiscount;
      }
      if (Number.isNaN(amount.advancePayment)) {
        return amount.amountAfterDiscount - Number(amount.securityDeposit);
      }
      if (Number.isNaN(amount.securityDeposit)) {
        return amount.amountAfterDiscount - Number(amount.advancePayment);
      } else {
        return Number(amount.amountAfterDiscount) - Number(amount.securityDeposit) - Number(amount.advancePayment);
      }
    }
  }, [rowsData, amount.discount, amount.securityDeposit, amount.advancePayment, amount.discountMode, amount.amountAfterAdjustment, amount.amountBeforeDiscount]);


  useEffect(() => {
    setamount({
      ...amount, discount: invoice?.discount,
      discountMode: invoice?.discountType,
      remarks: invoice?.remarks
    })
  }, [invoice])

  const discountModeValue = (() => {
    if (amount.discountMode === "PERCENTAGE") {
      return (
        { label: "%", value: "PERCENTAGE", options: "" }
      )
    }
    else {
      return (
        { label: "CASH", value: "AMOUNT", options: "" }
      )
    }
  })


  //discount Error
  const [errorMsgDiscount, setErrorMsgDiscount] = useState<any>(false);
  const [errorValsDiscount, setErrorValsDiscount] = useState<any>({});
  const [errorMsgAP, setErrorMsgAP] = useState<any>(false);
  const [errorValsAP, setErrorValsAP] = useState<any>({})
  const [errorMsgSD, setErrorMsgSD] = useState<any>(false);
  const [errorValsSD, setErrorValsSD] = useState<any>({})



  const validate = (values: any, type: any) => {
    const errors: any = {}
    const intValue = parseInt(values, 10); // Convert 'values' to an integer
    const amountAfterDiscountValue = parseInt(amount?.amountAfterDiscount, 10);
    const remarksEntered = amount?.remarks;

    const centerAdminThreshold = centerDetail?.centerAdminDiscountThreshold
    const primaryConsultantThreshold = centerDetail?.primaryConsultantDiscountThreshold

    const minThreshold = centerAdminThreshold !== null && primaryConsultantThreshold !== null
      ? Math.min(centerAdminThreshold, primaryConsultantThreshold)
      : centerAdminThreshold !== null
        ? centerAdminThreshold
        : primaryConsultantThreshold !== null
          ? primaryConsultantThreshold
          : 0;

    console.log(minThreshold, "min Threshold");





    if (type === "discount") {
      if (amount?.discountMode === "PERCENTAGE") {
        if (values < 0) {
          errors["discount"] = "Discount cannot be less than 0"
        }
        if (minThreshold > 0 && !remarksEntered && values > minThreshold) {
          errors["discount"] = `Discount is more than ${minThreshold}%, Please Enter Remarks`
        }
        if (values > 100) {
          errors["discount"] = "Discount entered cannot be more than 100%"
        }
      }

      if (amount.discountMode === "AMOUNT") {

        if (minThreshold > 0 && values > (minThreshold / 100 * amount.amountBeforeDiscount) && !remarksEntered) {
          errors["discount"] = `Discount is more than ${minThreshold}%, Please Enter Remarks`
        }
        // if (parseFloat(values) > amount.amountBeforeDiscount) {
        //   errors["discount"] = "Discount entered cannot be more than 100%"
        // }


      }

      if (JSON.stringify(errors) === '{}') {
        setErrorMsgDiscount(false);
      }
      else {
        setErrorMsgDiscount(true);
        setErrorValsDiscount(errors);
      }
    }

    if (type == "SD") {
      if (values > invoice?.securityDepositInHand) {
        errors["balanceSD"] = "Insufficient Balance"
      }
      if (intValue > amountAfterDiscountValue) {
        errors["balanceSD"] = "Amount entered is greater than invoice Amount"
      }
      if (JSON.stringify(errors) === '{}') {
        setErrorMsgSD(false);
      }
      else {
        setErrorMsgSD(true);
        setErrorValsSD(errors);
      }
    }
    if (type == "AP") {
      if (values > invoice?.totalAdvancePayment) {
        errors["balanceAP"] = "Insufficient Balance"
      }
      if (intValue > amountAfterDiscountValue) {
        errors["balanceAP"] = "Amount entered is greater than invoice Amount"
      }
      if (JSON.stringify(errors) === '{}') {
        setErrorMsgAP(false);
      }
      else {
        setErrorMsgAP(true);
        setErrorValsAP(errors);
      }
    }
  }


  useEffect(() => {
    validate(amount?.discount, "discount");
  }, [amount?.remarks, amount?.discount, amount?.discountMode, amount?.amountBeforeDiscount])



  //Popover Advance Payment
  const [anchorElAdvance, setAnchorElAdvance] = React.useState<HTMLButtonElement | null>(null);
  const handleClickAdvance = (event: React.MouseEvent<HTMLButtonElement>) => {

    setAnchorElAdvance(event.currentTarget);

  };
  const handleCloseAdvance = () => {
    setAnchorElAdvance(null);
  };
  const openAdvance = Boolean(anchorElAdvance);
  const idAdvance = openAdvance ? 'simple-popover' : undefined;

  //Popover Security Deposit

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {

    setAnchorEl(event.currentTarget);

  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;


  //Popover Insurance
  const [anchorElInsurance, setAnchorElInsurance] = React.useState<HTMLButtonElement | null>(null);
  const handleClickInsurance = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElInsurance(event.currentTarget);
  };
  const handleCloseInsurance = () => {
    setAnchorElInsurance(null);
  };

  const openInsurance = Boolean(anchorElInsurance);
  const idInsurance = open ? 'simple-popover' : undefined;
  //Toast 
  const [displayToast, toggleDisplayToast] = useState<any>()
  
  //Final Invoice 
  const saveInvoiceDetails = () => {
    if (amount.discount > 0 && amount?.remarks === "") {
      setErrorMsgDiscount(true);
      toggleDisplayToast({ text: "Please enter Remarks", type: "error" })
      return null;
    }

    const values2 = {
      discount: amount?.amountAfterDiscount >= 0 ? amount?.discount : 0,
      discountType: amount?.discountMode,
      remarks: amount?.remarks,
      invoiceItems: rowsData.map(({ rowId, ...rest }: any) => rest),
    }

    if (values2.discount === "") {
      values2.discount = 0;
    }

    if (!errorMsgDiscount) {
      if (readOnly) {
        redirectToPayments(invoiceId);
      }
      else {
        saveAndProceedInvoice(values2, invoice?.id).then((res: any) => {
          redirectToPayments(invoiceId);
          setLoading(false)
          toggleDisplayToast({ text: "Details have been saved.Please Proceed", type: "success" })
        }).catch((err: any) => {
          console.log(err)
          setLoading(false);
          console.log(err, "error");
          console.log(err?.response?.data?.code, "error code message");
          if (err?.response?.data?.code === "STAFF_ID_NOT_FOUND") {
            toggleDisplayToast({ text: err?.response?.data?.message, type: "error" })
          }
          else {
            toggleDisplayToast({ text: "Unable to Proceed", type: "error" })
          }
        })
      }
    }
    else {
      setErrorMsgDiscount(true);
      toggleDisplayToast({ text: "Please enter Remarks", type: "error" })
    }
  }

  //Select custom style
  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      opacity: state.isDisabled ? 1 : 1,
      backgroundColor: state.isDisabled ? "white" : "white",
      cursor: state.isDisabled ? "not-allowed" : "pointer",
      textTransform: "capitalize",
      border: "1px solid #ccd0e7",
      borderRadius: "10px"
      // add any other custom styles you want for the control component
    }),
    dropdownIndicator: (provided: any, state: any) => ({
      ...provided,
      paddingRight: '0px', // reduce the padding of the right side of the arrow
      paddingLeft: '0px', // reduce the padding of the left side of the arrow
    }),
  };

  const closeConsultantChargesModal = () => {
    setShowConsultationChargesPopUp(false)
    setSelectedInvoiceItem({})
  }

  const onConsultationChargesApply = () => {
    const newConsultationCharges = invoice?.suggestedConsultationCharges
    const tempRowsData = [...rowsData]
    const index = tempRowsData.findIndex((item: any) => item.rowId === selectedInvoiceItem.rowId);
    tempRowsData[index]["isSuggestedConsultationCharges"] = true;
    setRowsData(tempRowsData)
    updateEditableFields(index, { target: { name: "cost", value: newConsultationCharges } })
    setShowConsultationChargesPopUp(false)
    setSelectedInvoiceItem({})
    setShowConsultationChargesAlert(false)
  }

  return (
    <div className='billing-module-wrapper' id="billing-cover">
      <Modal show={showConsultationChargesPopUp} onHide={closeConsultantChargesModal}>
        <Modal.Header closeButton>
          <h5>Revise Service Charges</h5>
        </Modal.Header>
        <Modal.Body>
          <Alert variant='primary'>
            <div>
              <h6>Consultant's Suggestion</h6>
              <h5 className='fw-semibold'>{invoice?.suggestedConsultationCharges?.toFixed(2)}</h5>
            </div>
          </Alert>
          <div className='mt-4'>
            <h6 className='fw-medium fs-6'>Select Service to Modify</h6>
            {rowsData.filter((service: any) =>
              service.serviceId && service.serviceId.trim() !== '' && service?.archive !== true).map((item: any) => (
                <Card key={item?.rowId} className="mb-2" role='button' onClick={() => setSelectedInvoiceItem(item)}>
                  <Card.Body>
                    <div className='d-flex justify-content-between'>
                      <div><span className='me-2'><FontAwesomeIcon icon={selectedInvoiceItem.rowId === item.rowId ? faCircleDot : faCircle} /></span>{item.treatmentAndDetails}</div>
                      <div>{parseFloat(item.cost)?.toFixed(2)}</div>
                    </div>
                  </Card.Body>
                </Card>
              ))}
          </div>
          {selectedInvoiceItem?.rowId && <div className='mt-4'>
            <Alert variant={`${invoice?.suggestedConsultationCharges > selectedInvoiceItem.cost ? "success" : "danger"}`}>
              <div className='d-flex justify-content-between mb-3'>
                <div>Current Price for {selectedInvoiceItem?.treatmentAndDetails}</div>
                <div>{selectedInvoiceItem?.cost?.toFixed(2)}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div>Price Difference</div>
                <div>{invoice?.suggestedConsultationCharges?.toFixed(2) - selectedInvoiceItem?.cost?.toFixed(2)}</div>
              </div>
              <hr />
              <div className='d-flex justify-content-between'>
                <div>New Price</div>
                <div>{invoice?.suggestedConsultationCharges?.toFixed(2)}</div>
              </div>
            </Alert>
          </div>}
        </Modal.Body>
        <Modal.Footer>
          {selectedInvoiceItem?.rowId && (
            <Button variant='primary' onClick={onConsultationChargesApply}>Apply Suggested Price</Button>)}
          <Button variant='outline-secondary' onClick={closeConsultantChargesModal}>Ignore</Button>
        </Modal.Footer>
      </Modal >
      {
        loading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        )
      }
      {/* Section 1 */}
      <div className='top-heading-wrapper'>
        <div className='invoice-heading-container'>
          <div
            className="approval-back-image"
            onClick={() => {

              history.goBack()
            }}
          >
            <img
              src={"../../../../assets/images/back-icon.svg"}
              alt="back button"
              className="image-top-wrapper"
            />
          </div>
          <div className='Heading-Billing'>Invoice : {moment(invoice?.appointmentDate
          ).format("DD-MM-YYYY")}</div>
        </div>
        <div className='insurance-container'>
          <div>
            <div className='insurance-content'>{invoice?.patientCategory}</div>
            <div className='insurance-content'>{invoice?.subCategory}</div>
          </div>
          <button className='advance-payment-button' onClick={handleClickInsurance}>
            <img
              className='image-top-wrapper'
              src={"../../../../assets/images/Insurance.svg"}
            />
          </button>


        </div>
        <div className='security-advance-container'>
          <div className='container-payment'>
            <button className='advance-payment-button' onClick={handleClick} >
              <MocImage className='image-top-wrappers' src={"../../../../assets/images/Money.svg"}
              />
            </button>
            <div className='subheading-payment'>Security Deposit:</div>
            <div className='subheading-value'>{invoice?.totalSecurityDeposit?.toFixed(2)}</div>
            <div className='subheading-payment'>Advance:</div>
            <div className='subheading-value'>{invoice?.totalAdvancePayment?.toFixed(2)}</div>

            <button className='advance-payment-button' onClick={handleClickAdvance} >
              <MocImage className='image-top-wrappers' src={"../../../../assets/images/Money.svg"}
              />
            </button>
          </div>



        </div>
      </div>


      {/* Section 2 */}
      <div className='top-subheading-wrapper'>
        <div className='subHeading-Billing'>{invoice?.isVip ? <><div>***Masked***</div></> : <>{invoice?.patientName}</>} &nbsp; ({invoice?.mocPatientId
        })
          &nbsp;
          {invoice?.appointmentType}
        </div>
      </div>
      {/* Section 3 */}
      <div className='top-subheading-wrapper'>
        <div className='subHeading-Billing'>{invoice?.mocAppointmentId
        }&nbsp;
        </div>
      </div>

      <div className='my-2 m-auto w-50'>
        {showConsultationChargesAlert && (
          <Alert variant="warning">
            <div className='d-flex justify-content-between'>
              <div className='d-flex'>
                <FontAwesomeIcon icon={faCircleExclamation} className='me-2' size='lg' />
                <div>
                  <h6>Consultant suggests price revision</h6>
                  <div>Recommended adjustment: {invoice?.suggestedConsultationCharges}</div>
                </div>
              </div>
              <Button
                className='m-2'
                variant='warning'
                onClick={() => {
                  setShowConsultationChargesPopUp(true)
                }}
              >
                Review Changes
              </Button>
            </div>
          </Alert>
        )}
      </div>

      {/* Section4 */}
      <div className='d-flex justify-content-end'>
        <Button className="common-button">
          {invoice?.isEditable ? <><span><LockOpenIcon /></span></> : <span><LockIcon /></span>}
        </Button>
        <Button className="common-button">
          Pending Bills Due-{invoice?.patientPendingAmount?.toFixed(2)}
        </Button>
      </div>

      {/* Section 4 */}

      <div className='treatments-and-products-wrapper'>
        <div className="col-sm-12 table-bill" >
          <table className="table">
            <thead>
              <tr>
                <th> &nbsp; &nbsp; Treatments and Products</th>
                <th></th>
                <th>Completed By</th>
                <th>Cost</th>
                <th>Discount</th>
                <th className='discount-percentage'></th>
                <th>Qty</th>
                <th>Taxable Amt</th>
                {/* <th>GST</th> */}
                <th>CGST</th>
                <th>SGST</th>
                <th>IGST</th>
                <th>Total Cost</th>
                <th>
                  <button
                    className="btn btn-outline-success"
                    onClick={addTableRows}
                  >
                    +
                  </button>
                </th>
              </tr>

            </thead>
            <tbody>
              <TableRows
                autofillData={autofillData}
                invoice={invoice}
                rowsData={rowsData}
                deleteTableRows={deleteTableRows}
                handleChange={handleChange}
                readOnly={readOnly}
                updateEditableFields={updateEditableFields}
                handleReasonChange={(remarks: any, index: any) => {
                  const rowsInput = [...rowsData]
                  rowsInput[index]["remarks"] = remarks
                  setRowsData(rowsInput)
                }}
                updateCostBasedQuantity={updateCostBasedQuantity}
              />
            </tbody>
          </table>
        </div>
        <hr />
        <div className='common-wrapper' id="wrapper-total">
          <div className='subheadings'>Total:</div>
          <div className='subheadings'>{amount.amountBeforeDiscount}</div>
        </div>
        <hr />
        <div className='common-wrapper'>
          <div className='subheadings-small'>Discounts:</div>
          <input
            type="text"
            className="form-control-width"
            id="discount"
            name="discount"
            disabled={amount.amountBeforeDiscount <= 0 ? true : readOnly}
            value={amount.discount}
            onChange={(e: any) => {
              const discountValue = e.target.value;
              if (amount?.discountMode === "PERCENTAGE") {
                if (discountValue <= 100) {
                  const amountBeforeDiscount = parseFloat(amount?.amountBeforeDiscount || 0);
                  let newDiscount = discountValue;
                  if (amountBeforeDiscount >= e.target.value) {
                    setamount({ ...amount, discount: newDiscount });
                  }
                  if (amountBeforeDiscount == 0) {
                    setamount({ ...amount, discount: 0 });
                  }
                  validate(discountValue, "discount");
                }
              } else {
                const amountBeforeDiscount = parseFloat(amount?.amountBeforeDiscount || 0);
                let newDiscount = discountValue;
                if (amountBeforeDiscount >= e.target.value) {
                  setamount({ ...amount, discount: newDiscount });
                }
                if (amountBeforeDiscount == 0) {
                  setamount({ ...amount, discount: 0 });
                }
                validate(discountValue, "discount");
              }
            }}

          />{" "}
          <div className='main-discount-type' style={{ width: '80px' }}>
            <Select
              className="select-payment"
              name="discountMode"
              styles={customStyles}
              isDisabled={amount.amountBeforeDiscount <= 0 ? true : readOnly}
              value={
                amount?.discountMode === "PERCENTAGE" ?
                  {
                    label: "%",
                    value: amount.discountMode,
                  }
                  : {
                    label: "CASH",
                    value: amount.discountMode,
                  }}
              options={discountDropdown}
              onChange={(evnt: any) => {
                setamount({ ...amount, discountMode: evnt?.value, discount: 0 })
              }}
            />
          </div>

        </div>
        {errorMsgDiscount ? <div className='errorMsg'>{errorValsDiscount.discount}</div> : <div className="errorMsg"></div>}

        <div className='common-wrapper' id="remarks-wrapper">
          <div className='subheadings-small'>Remarks</div>
          <textarea
            id="textarea-remark"
            className="form-control-width"
            name="remarks"
            rows={5}
            cols={10}
            disabled={readOnly}
            value={amount?.remarks}
            onChange={(e: any) => {
              setamount({ ...amount, remarks: e.target.value });

              //setErrorMsgDiscount(false);

            }}
          />{" "}
        </div>
        <hr />
        <div className='common-wrapper' id="wrapper-discount">
          <div className='subheadings'>Amount After Discount:</div>
          <div className='subheadings'>{Math.max(amount.amountAfterDiscount, 0)}</div>
        </div>
        <hr />
        {/* *******Deprecated******* */}
        {/* Advance Payment and Security Deposit starts */}
        {/* <div className='common-wrapper'>
          <div className='subheadings-small'>Adjust Security Deposit</div>
          <input
            type="number"
            className="form-control-width"
            name="securityDeposit"
            value={amount.securityDeposit}
            onChange={(e: any) => {
              const inputValue = parseInt(e.target.value);
              if (inputValue >= 0 || e.target.value === '') {
                setamount({ ...amount, securityDeposit: inputValue });
                validate(e.target.value, "SD");
              }
            }}
          />
        </div> 
        {errorMsgSD ? <div className='errorMsg'>{errorValsSD.balanceSD}</div> : <div className="errorMsg"></div>}
        <div className='common-wrapper' id="advance-wrapper">
          <div className='subheadings-small'>Adjust Advance Payment</div>
          <input
            type="number"
            className="form-control-width"
            name="advancePayment"
            value={amount.advancePayment}
            onChange={(e: any) => {
              const inputValue = parseInt(e.target.value);
              if (inputValue >= 0 || e.target.value === '') {
                setamount({ ...amount, advancePayment: parseInt(e.target.value) });
                validate(e.target.value, "AP")
              }
            }}
          />
        </div>
        {errorMsgAP ? <div className='errorMsg'>{errorValsAP.balanceAP}</div> : <div className="errorMsg"></div>} */}
        {/* Advance Payment and Security Deposit ends */}
        {/* <div className='common-wrapper' id="wrapper-total-payable">
          <div className='subheadings'>Invoice Amount:</div>
          <div className='subheadings'>{amount.amountAfterAdjustment}</div>
        </div> */}

        {/* end of table wrapper */}
      </div>


      <div className='save'>
        <Button className='common-button'
          onClick={() => {
            if (invoice?.id)
              saveInvoiceDetails()
          }}
        >{"Save and Continue"}</Button>
      </div>

      <RenderPopover
        invoice={invoice}
        handleClick={handleClick}
        handleClose={handleClose}
        anchorEl={anchorEl}
        open={open}
        centerId={centerDetail?.id}

      />
      <RenderPopoverInsurance

        invoice={invoice}
        category={invoice?.patientCategory}
        subCategory={invoice?.subCategory}
        handleClickInsurance={handleClickInsurance}
        handleCloseInsurance={handleCloseInsurance}
        anchorElInsurance={anchorElInsurance}
        openInsurance={openInsurance}
        readOnly={readOnly}
      />
      <RenderPopoverAdvance
        invoice={invoice}
        handleClick={handleClickAdvance}
        handleClose={handleCloseAdvance}
        anchorEl={anchorElAdvance}
        open={openAdvance}
        centerId={centerDetail?.id}
      />
      {/* {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => {
            toggleDisplayToast(false)
            if (displayToast?.type === "success") {
              window.location.reload();
            }
          }}
          onCloseText="Close"
          onClickText={null}
        />
      )} */}
      {displayToast && (
        <><Toast
          textMessage={displayToast?.text}
          onClose={() => toggleDisplayToast(false)}
          onCloseText="Close"
          onClickText={displayToast?.onClickText ? displayToast?.onClickText : null}
          textarea={displayToast?.textarea ? displayToast?.textarea : null}
          textareaContent={displayToast?.textareaContent}
          onClick={(index: any, textArea: any) => {
            rowsData[index].reason = textArea;
            if (textArea.length > 0) {
              const rows = [...rowsData]
              rows[index]["archive"] = true
              setRowsData(rows)
              toggleDisplayToast(false)
              if (rows[index]?.isSuggestedConsultationCharges) {
                setShowConsultationChargesAlert(true)
              }
            }
          }
          }
          type={displayToast?.type} /></>
      )}
    </div>
  )
}
export default MainBillingModule

